import { customLocalStorage, customSessionStorage } from '@crehana/utils';

const useDownloadResource = (
  downloadUrlB2B: string | null | undefined,
  downloadUrlB2C: string | null | undefined,
) => {
  const onDownload = () => {
    if (downloadUrlB2B) {
      customSessionStorage.removeItem('downloadUrlB2B');
      customSessionStorage.removeItem('detailResourceUrl');
      customLocalStorage.removeItem('detailResourceUrl');
      // Info: logEvent callback is not used because it is failing
      window.open(downloadUrlB2B);
    } else if (downloadUrlB2C) {
      customSessionStorage.removeItem('downloadUrlB2C');
      // Info: logEvent callback is not used because it is failing
      window.open(`${downloadUrlB2C}?platform=direct`);
    }

    window.location.href = '/';
  };

  return {
    onDownload,
  };
};

export default useDownloadResource;
